import { TAbstractCatalogItem } from './AbstractCatalogItem'

export interface TDynamicCatalogItem extends TAbstractCatalogItem {
}

export const create = (data?: Partial<TDynamicCatalogItem>): TDynamicCatalogItem => ({
  _id: '',
  id: 0,
  active: true,
  parentId: 0,
  catalogId: '',
  isCategory: false,
  extraId: '',
  name: '',
  order: 0,
  fields: [],
  path: '',
  ...data,
})
